<script>
    import {FormSubmitted} from '../store';
    export let btnTitle = 'Proceed';
    export let JoinAs;
    let temp = '66%';
    let emailAdd;
    let proceed = false;
    let showdiv = false;
    let show = true;
    let isDisabled = false;
    $: console.log('JoinAs', JoinAs);

    /**
     */
    async function saveData() {
        isDisabled = true;
        const functionUrl =
            'https://us-central1-opusai.cloudfunctions.net/updateWorkSheet';
        await fetch(functionUrl, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                data: [emailAdd, JoinAs],
            }),
        }).then((res) => {
            if (res.status === 401) {
                proceed = false;
                showdiv.style.display = 'block';
                isDisabled = false;
            } else if (res.status === 200) {
                show = false;
                FormSubmitted.update((n) => true);
                proceed = true;
                showdiv.style.display = 'none';
            }
        });
        console.log('i am enabling', isDisabled);
    }
    if ($FormSubmitted) {
        proceed = true;
    }
    $: {
        if (proceed === true) {
            temp = '59%';
        }
    }
</script>

<div role="presentation" class="box" on:click />
<div class="boxWrraperInner">
    {#if proceed === false}
        <div class="secondBox" style="">
            <p>
                <span style="font-size: 1.2vw;font-weight: 900;">
                    We're not ready yet :(
                </span> <br />Join our waitlist
            </p>
            <div>
                <form on:submit|preventDefault={saveData}>
                    <div class="input-field">
                        <input
                            bind:value={emailAdd}
                            type="email"
                            required
                            placeholder="Enter your Email..."
                        />
                    </div>
                    <div class="error-div" bind:this={showdiv}>
                        <p style=" color: red; font-size: 0.5vw;">
                            Please Enter Vaild Email
                        </p>
                    </div>
                    <div class="btn">
                        <button type="submit" disabled={isDisabled}
                            >{btnTitle}</button
                        >
                    </div>
                </form>
            </div>
        </div>
    {:else if proceed === true}
        <div class="thankyou-box">
            <p class="thankyou-text1">
                Awesome! Thanks for submitting your email.
            </p>
            <p class="thankyou-text2">
                We'll notify you as we roll out invites in the coming weeks!
            </p>
            <h1 class="shareit">Share it on</h1>
            <div class="logoWrraper">
                <div class="imgwrraper">
                    <a
                        href="https://twitter.com/intent/tweet?text=I%20just%20signed%20up%20for%20Opus%27%20waitlist.%20Opus%20is%20a%20text-to-videogames%20platform.%20join%20the%20wait%20list%20at%20opus.ai%20%23OpusAI"
                        target="_blank"
                    >
                        <img
                            src="/images/team/twiter.svg"
                            alt="twitter"
                            width="100%"
                            height="100%"
                        />
                    </a>
                </div>
                <div class="imgwrraper">
                    <a
                        href="https://www.linkedin.com/sharing/share-offsite/?url=opus.ai"
                        target="_blank"
                    >
                        <img
                            src="/images/team/linkden.svg"
                            alt="linkden"
                            width="100%"
                            height="100%"
                        />
                    </a>
                </div>
                <div class="imgwrraper">
                    <a
                        href="https://www.facebook.com/sharer/sharer.php?u=opus.ai"
                        target="_blank"
                    >
                        <img
                            src="/images/team/facebook.svg"
                            alt="facebook"
                            width="100%"
                            height="100%"
                        />
                    </a>
                </div>
                <div class="imgwrraper">
                    <a
                        href="https://vk.com/share.php?url=opus.ai"
                        target="_blank"
                    >
                        <img
                            src="/images/team/vk.svg"
                            alt="VK"
                            width="100%"
                            height="100%"
                        />
                    </a>
                </div>
            </div>
        </div>
    {/if}
    <div class="close-btn" style="top: {temp}">
        <p role="presentation" class="cancelBtn" on:click>close</p>
    </div>
</div>

<!-- </div> -->
<style>
    .box {
        top: 0vw;
        left: 0vw;
        width: 100%;
        z-index: 10;
        height: 100%;
        position: fixed;
        text-align: center;
        background: rgba(0, 0, 0, 0.8);
    }
    .boxWrraperInner {
        top: 50%;
        left: 50%;
        z-index: 11;
        text-align: center;
        position: fixed;
        transform: translate(-50%, -50%);
    }
    .shareit {
        font-size: 1.2vw;
        font-weight: 900;
        text-align: center;
        line-height: 1.306vw;
        font-family: "Orbitron";
        margin-top: 2vw;
        color: #ff007f;
    }
    .logoWrraper {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 2vw;
    }
    .logoWrraper .imgwrraper {
        height: 2vw;
        width: 2vw;
        margin-right: 2vw;
    }
    .error-div {
        margin-top: -3vw;
        margin-left: -21.7vw;
        margin-bottom: -0.8vw;
        display: none;
    }
    .input-field {
        margin-top: 1vw;
    }
    .thankyou-box {
        width: 40.885vw;
        height: auto;
        background-color: white;
        background-color: white;
        margin: auto;
        border: 0.1vw solid #ff007f;
    }
    .thankyou-box .thankyou-text1 {
        padding-top: 1.2vw;
        color: black;
        font-family: "Orbitron";
        font-size: 1.042vw;
        font-weight: 900;
        text-align: center;
    }
    .thankyou-box .thankyou-text2 {
        color: black;
        font-size: 0.6vw;
        font-weight: 400;
        font-family: "Orbitron";
        text-align: center;
    }
    .secondBox {
        width: 40.885vw;
        height: 15.573vw;
        background-color: white;
        margin: auto;
    }
    .cancelBtn {
        color: white;
        font-size: 1.042vw;
        font-weight: 400;
        margin-top: 1.667vw;
        font-family: "Orbitron";
        position: relative;
        z-index: 12;
        cursor: pointer;
    }
    .secondBox p {
        font-size: 1.042vw;
        font-weight: 500;
        width: 33.281vw;
        margin: auto;
        color: black;
        padding-top: 3.2vw;
        text-align: center;
        line-height: 1.306vw;
        font-family: "Orbitron";
    }
    .secondBox button {
        font-family: "Orbitron";
        width: 16.094vw;
        height: 2.083vw;
        background-color: #ff007f;
        color: white;
        border: none;
        font-size: 0.625vw;
        font-weight: 800;
        cursor: pointer;
    }
    .secondBox input {
        font-family: "Orbitron";
        width: 14.7vw;
        height: 2.083vw;
        color: rgb(0, 0, 0);
        border: 0.052vw solid #b2b2b2;
        font-size: 0.521vw;
        font-weight: 400;
        padding-left: 1.042vw;
    }
    .secondBox button:hover {
        font-family: "Orbitron";
        width: 16.094vw;
        height: 2.083vw;
        background-color: black;
        color: white;
        border: none;
        font-size: 0.625vw;
        font-weight: 800;
        transition-duration: 1s;
        cursor: pointer;
    }
    .btn {
        margin-top: 1vw;
    }
</style>
